<template>
  <b-layout :colors="$site.colors" :header-title="$t('pages.book.waitlist.customer.title')" :header-back-route="{ path: '/book-now/availability' }" :breadcrumbs="breadcrumbs">
    <b-container class="mt-12">
      <b-summary>
        <template #summary>
          <booking-detail :stage="stage" />
        </template>

        <div>
          <customer-select :title="$t('pages.book.waitlist.customer.yourDetails')" :allow-new-registration="$site.settings.allowNewRegistrations" @selected="selectedCustomer" />
        </div>
      </b-summary>
    </b-container>
  </b-layout>
</template>

<script>
import CustomerSelect from '@/components/customer/elements/Select.vue'
import BookingDetail, { BookingStage, createBookingRoute } from '@/components/booking/elements/Detail.vue'

definePageMeta({
  tabs: ['online'],
  middleware: ['redirects']
});

export default defineNuxtComponent({
  components: {
    CustomerSelect,
    BookingDetail
  },
  async asyncData () {
    /* if (app.$auth.user && !route.query.override) {
      store.dispatch('booking/setSelectedCustomer', app.$auth.user.selectionObject)

      const bookingUrlQuery = store.getters['booking/urlQuery']
      redirect(createBookingRoute(bookingUrlQuery, BookingStage.WAITLIST_AVAILABILITY))
    } */

    const route = useRoute()
    const { $auth } = useNuxtApp()
    const bookingStore = useBookingStore()

    await bookingStore.setFromUrlQuery(route.query)

    if ($auth.user.value && !route.query.override) {
      await bookingStore.setSelectedCustomer($auth.user.value.selectionObject)
    }

    return {}
  },
  data () {
    return {
      stage: BookingStage.WAITLIST_CUSTOMER
    }
  },
  computed: {
    backRoute () {
      const bookingUrlQuery = this.$store.getters['booking/urlQuery']
      return createBookingRoute(bookingUrlQuery, BookingStage.AVAILABILITY)
    },
    breadcrumbs () {
      const bookingUrlQuery = this.$store.getters['booking/urlQuery']

      return [
        { text: this.$site.tabs.getName('book', 'Book'), to: createBookingRoute(bookingUrlQuery, BookingStage.SERVICES) },
        { text: this.$t('pages.book.waitlist.breadcrumbs.availability'), to: createBookingRoute(bookingUrlQuery, BookingStage.AVAILABILITY) },
        { text: this.$t('pages.book.waitlist.breadcrumbs.waitlist'), active: true },
        { text: this.$t('pages.book.waitlist.breadcrumbs.customer'), active: true }
      ]
    }
  },
  methods: {
    async selectedCustomer ({ customer }) {
      // await this.$store.dispatch('booking/setSelectedCustomer', customer)
      // const bookingUrlQuery = this.$store.getters['booking/urlQuery']
      // this.$router.push(createBookingRoute(bookingUrlQuery, BookingStage.WAITLIST_AVAILABILITY))

      await this.$store.dispatch('booking/setSelectedCustomer', customer)

      const bookingUrlQuery = this.$store.getters['booking/urlQuery']

      this.$router.push(createBookingRoute(bookingUrlQuery, BookingStage.WAITLIST_AVAILABILITY))
    }
  }
})
</script>
